// extracted by mini-css-extract-plugin
export var alertIcon = "_ti-0";